import { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./SignupCode.module.css";
import logo from "../../../assets/images/logo.png";
import { Modal, SubmitButton, TextComponent } from "../../../components";
import { IoChevronBackOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import { PiSealCheck } from "react-icons/pi";

import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

function SignupCode() {
  const location = useLocation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);

  console.log("Location", location?.state);

  const formState = [{ message: "Please Enter Otp", value: otp }];

  const handleChange = (otp) => setOtp(otp);

  // const naviagteScreens = () => {
  //   setIsSuccessFulModal(false)
  //   if (location?.state?.role == roles.user) {
  //     navigate("/moduleRegistration", { state: "userModule" });
  //   } else {
  //     navigate("/accountSetup");
  //   }
  // };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.rightWidthCont}>
          <div className={styles.backDiv} onClick={() => navigate("/")}>
            <IoChevronBackOutline color="var(--white-color)" />
            <TextComponent
              style={{ color: "var(--white-color)", cursor: "pointer" }}
              fontFamily={"Urbanist-light"}
              text={"Back to login"}
            />
          </div>
          <div className={styles.textDiv}>
            <TextComponent
              className={styles.welcomeHeading}
              text={"Signup Code"}
            />
            <TextComponent
              className={styles.welcomeText}
              style={{ color: "var(--white-color)" }}
              text={"Please enter the signup code provided by Admin"}
            />
          </div>
          <div
            className={styles.enterCodeDiv}
            //   style={{textDecorationColor}}
          >
            <TextComponent
              style={{ color: "var(--white-color)" }}
              text={"Enter Code"}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <OTPInput
              value={otp}
              shouldAutoFocus={true}
              onChange={handleChange}
              isInputNum={true}
              inputType="number"
              numInputs={5}
              separator={<span style={{ width: "8px" }}></span>}
              containerStyle={styles.otpInputDiv}
              inputStyle={{
                width: "100%",
                height: "68px",
                border: "1px solid #F95110",
                borderRadius: "50%",
                fontSize: "25px",
              }}
              // inputStyle={styles.otpInput}

              renderInput={(props) => <input type="number" {...props} />}
            />
          </div>
          <div className={styles.btn}>
            <SubmitButton
              title={"Verify"}
              primary
              btnContainerClass={styles.Verify_btnContainer}
              btnClass={`${styles.Verify_btn}`}
              onClick={() => navigate("/signup")}
            />
          </div>
        </div>
      </div>
      <Modal
        open={isSuccessfulModal}
        onCancel={() => setIsSuccessFulModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Email Verified successfully"}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"Setup  your account"}
        onBtnPress={() => setIsSuccessFulModal(false)}
        // onBtnPress={onPressVerify}
      ></Modal>
    </div>
  );
}

export default SignupCode;
